// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"135":"light","588":"dark"}[chunkId] || chunkId) + "." + {"135":"85641cb5","169":"eae383a1","588":"85641cb5"}[chunkId] + ".chunk.css";
};